import { AccountProvider } from "./../../providers/account/account";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FisoMathProvider } from "../../providers/fiso-math/fiso-math";

import * as _ from "lodash";
import { LoadingController, NavParams } from "ionic-angular";
import { RoomProvider } from "../../providers/room/room";
import { FLASH_CARD_TYPE } from "../flash-card-container/flash-card-container";
import APP_CONFIG from "../../app/app.config";
import NUMBER_OF_NUMBERS from "../../constants/NUMBER_OF_NUMBERS";
import NUMBER_OF_ROWS from "../../constants/NUMBER_OF_ROWS";
import ALGORITHMS from "../../constants/ALGORITHMS";
import VOICE_CODES from "../../constants/VOICE_CODES";
import SPEEDS from "../../constants/SPEEDS";

declare let $: any;

/**
 * Generated class for the SorobanMathContainerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "soroban-math-container",
  templateUrl: "soroban-math-container.html",
  providers: [RoomProvider, AccountProvider],
})
export class SorobanMathContainerComponent implements OnInit, OnDestroy {
  @Input() algorithm = null;
  @Input() type = null;
  @Input() options: any = {};
  examlevels: any = [];
  examLevelIndex: any = "0";

  @Input() isFlashCard = false;
  @Input() isFullAnswer = false;
  @Input() examMode = false;
  @Input() level = null;
  @Input() sub_level = null;
  @Input() board_name = null;

  giongDocs = VOICE_CODES;
  tocDoDocs = SPEEDS;

  isShowSummary = false;

  log_group = null;

  config: any = {
    category_id: "",
    game_type: "see",
    giong_doc: "hn_female_ngochuyen_full_48k-fhg",
    toc_do_doc: "0.8",
    disabled: {
      number_of_numbers: false,
      timers: false,
      number_of_questions: false,
      delay_timers: false,
    },
    numbers: [1, 2],
    row_items: [
      2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ],
    timer_items: [0.2, 0.3, 0.5, 0.7, 1, 1.5, 2, 3, 4, 5],
    // timer_items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30, 60],
    answer_timer_items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30, 60],
    number_of_numbers: "2",
    timers: "5",
    current_questions: 1,
    number_of_questions: "20",
    number_of_question_items: ["10", "20", "30"],
    number_of_rows: "4",
    answer_timers: "10",
    hidden_number_of_rows: false,
  };

  trainingQuestions = [];
  categories = [];

  currentNumberIndex: any = 0;
  currentNumber: any = "";
  numbers: any = null;
  count_correct_numbers: any = 0;

  currentAnswer: any = "";
  myAnswer: any = "";
  timeoutShowResultSignForText: any = null;
  timeoutEnableEnterAnswered: any = null;
  timeoutAnswer: any = null;

  isGaming = false;
  isTry = false;
  isShowResultSignForText = false;
  isEnableEnterAnswered = false;

  isShowFullAnswer = false;
  isSuccess = false;
  isFail = false;
  isBravo = false;
  bravoText = "GOOD";
  isReStart = false;

  public room: any = null;
  public user_id: any = null;
  public isDemo: any = false;
  public fight_rounds = [];

  current_second = 0;

  constructor(
    public fisoMathProvider: FisoMathProvider,
    public navParams: NavParams,
    public roomProvider: RoomProvider,
    public accountProvider: AccountProvider,
    public loadingCtrl: LoadingController
  ) {
    console.log("Hello SorobanMathContainerComponent Component");
    this.isDemo = window.localStorage.getItem("TOKEN_KEY") === "demo";
  }

  ngOnInit() {
    this.config = { ...this.config, ...this.options };
    this.getRoom();
    this.loadTrainingQuestions();

    this.examlevels = this.fisoMathProvider.examlevels(this.level);
    if (this.examMode) {
      this.config.answer_timers = "5";
      this.config.answer_timer_items = [5, 6, 7, 8, 9, 10, 15, 20, 30, 60];
      this.changeExamLevel();
    }

    // for (const i = 0; i <= 100;)
    // this.generateSoundForNumbers();
  }

  async generateSoundForNumbers() {
    for (let algorithm of ALGORITHMS) {
      this.algorithm = algorithm.code;

      for (let i = 0; i < 5; i++) {
        console.log("[" + this.algorithm + "] Đang khởi chạy STT: " + i);

        for (let numberNumber of NUMBER_OF_NUMBERS) {
          this.config.number_of_numbers = `${numberNumber.code}`;

          for (let numberRow of NUMBER_OF_ROWS) {
            this.config.number_of_rows = `${numberRow.code}`;

            const numbers = this.generateNumbers();
            const strNumbers = this.generateNumbersStringPattern(numbers);

            if (strNumbers === " =") {
              continue;
            }

            await this.fisoMathProvider.generateSound(
              strNumbers,
              this.config.number_of_numbers,
              this.config.number_of_rows,
              this.algorithm
            );
          }
        }
      }
    }

    console.log("DONE generateSoundForNumbers");
  }

  loadTrainingQuestions() {
    if (this.board_name !== "training") {
      return;
    }

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loader.present();

    let params: any = {
      page: 0,
      ppp: 10000,
      order_by: "id",
      order_asc: "asc",
      post_type: "questions",
    };

    if (this.config.category_id) {
      params.category_id = this.config.category_id;
    }

    this.fisoMathProvider.training_questions(params).subscribe(
      (resp: any) => {
        loader.dismiss();
        this.trainingQuestions = resp.data || [];
        this.categories = resp.categories || [];
      },
      (err) => {
        console.log(err);
        loader.dismiss();
      }
    );
  }

  getRoom() {
    this.user_id = window.localStorage.getItem("USER_ID");
    this.room = this.navParams.get("room");
  }

  public intervalCountNumbers: any = null;

  callAISounds(strNumbers, cb = null, err = null) {
    if (this.config.game_type !== "listen") {
      err();
      return;
    }

    const playSoundFromUrl = (url) => {
      const audio = new Audio(url);
      audio.play();

      audio.addEventListener("ended", () => {
        if (cb) {
          cb();
        }
      });
    };

    this.accountProvider
      .sound({
        speed_rate: this.config.toc_do_doc,
        voice_code: this.config.giong_doc,

        algorithm: this.algorithm,
        number_of_numbers: this.config.number_of_numbers,
        number_of_rows: this.config.number_of_rows
      })
      .subscribe((resp: any) => {
        this.numbers = resp.data.numbers;
        this.currentAnswer = this.calculateNumbers(this.numbers);

        setTimeout(
          () => playSoundFromUrl(resp.data.url),
          this.config.number_of_rows * 400
        );
      });

    // fetch(APP_CONFIG.baseURL + "/acco", {
    //   method: "post",
    //   headers: {
    //     "api-key": "scZ3376Etvoo0coBayGp57w06s6Z5Was",
    //     speed: this.config.toc_do_doc,
    //     voice: this.config.giong_doc,
    //   },
    //   body: strNumbers,
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     setTimeout(
    //       () => playSoundFromUrl(data.async),
    //       this.config.number_of_rows * 400
    //     );
    //   });
  }

  generateNumbersString(numbers = []) {
    const str = numbers.map((o) => {
      switch (o) {
        case "+":
          return "cộng";
        case "-":
          return "trừ";
        case "x":
          return "nhân";
        case ":":
          return "chia";
        case ".":
          return "chấm";
        default:
          return o;
      }
    });

    return `${str} bằng`;
  }

  generateNumbersStringPattern(numbers = []) {
    const str = numbers.map((o) => {
      switch (o) {
        case "+":
          return " + ";
        case "-":
          return " - ";
        case "x":
          return " x ";
        case ":":
          return " : ";
        case ".":
          return " . ";
        default:
          return o;
      }
    });

    return `${str.join("")} =`;
  }

  try() {
    $(".nav-bar").addClass("disabled");

    this.isTry = true;
    this.isGaming = true;

    this.config.timers = parseFloat(this.config.timers);
    this.config.number_of_rows = parseInt(this.config.number_of_rows);
    this.config.answer_timers = parseFloat(this.config.answer_timers);

    // check flash
    this.numbers = this.generateNumbers();

    let intervalSeconds =
      this.config.timers * this.config.number_of_rows * 1000;
    let intervalSecondsForAnswer =
      this.config.timers * (this.config.number_of_rows - 1) * 1000;

    const callbackInterval = (
      customer_intervalSeconds = null,
      custom_intervalSecondsForAnswer
    ) => {
      this.timeoutShowResultSignForText = setTimeout(() => {
        this.isShowResultSignForText = true;
        this.isEnableEnterAnswered = true;
        // this.playSound('bang.mp3');

        setTimeout(() => {
          const ele_math_container_main_controls_left_answer =
            document.getElementById("math_container_main_controls_left_answer");
          console.log(ele_math_container_main_controls_left_answer);
          if (!ele_math_container_main_controls_left_answer) {
            return;
          }
          ele_math_container_main_controls_left_answer.focus();
          $(".scroll-content").addClass("flowhidden");
          $(".app-root").addClass("flowhidden");
        }, 800);
      }, customer_intervalSeconds || intervalSeconds);

      this.timeoutEnableEnterAnswered = setTimeout(() => {
        if (this.room) {
          return;
        }

        this.isEnableEnterAnswered = true;
        setTimeout(() => {
          document
            .getElementById("math_container_main_controls_left_answer")
            .focus();
          $(".scroll-content").addClass("flowhidden");
          $(".app-root").addClass("flowhidden");
        }, 400);
      }, custom_intervalSecondsForAnswer || intervalSecondsForAnswer);
    };

    if (this.isFlashCard) {
      this.currentAnswer = this.numbers;
      this.currentNumber = this.numbers;

      this.playSound(this.currentNumber, true);
      intervalSeconds = this.config.timers * 1000;
      intervalSecondsForAnswer = (this.config.timers - 1) * 1000;

      callbackInterval(null, null);
    } else {
      this.currentAnswer = this.calculateNumbers(this.numbers);
      this.currentNumberIndex = 0;
      this.currentNumber = this.numbers[this.currentNumberIndex];

      // this.playSound(this.currentNumber, true);

      this.callAISounds(
        this.generateNumbersString(this.numbers),
        () => callbackInterval(100, (this.config.timers - 1) * 1000),
        () => {
          this.intervalCountNumbers = setInterval(() => {
            this.currentNumberIndex = this.currentNumberIndex + 2;
            if (!this.numbers[this.currentNumberIndex]) {
              clearInterval(this.intervalCountNumbers);
              return;
            }

            this.currentNumber = this.numbers[this.currentNumberIndex];
            if (this.numbers[this.currentNumberIndex - 1]) {
              this.currentNumber =
                this.numbers[this.currentNumberIndex - 1] + this.currentNumber;
              this.playSound(this.currentNumber, true);
            }
          }, this.config.timers * 1000);

          callbackInterval(null, null);
        }
      );
    }
  }

  start() {
    $(".nav-bar").addClass("disabled");

    this.config.current_questions = 1;
    this.log_group = this.fisoMathProvider.guid();
    this.isReStart = false;

    // setup try and start
    this.isTry = false;
    this.isGaming = true;

    if (this.room) {
      this.loadFightRounds();
    } else {
      this.startRound();
    }
  }

  loadFightRounds() {
    if (
      this.room &&
      parseInt(this.user_id) !== parseInt(this.room.author_post_id)
    ) {
      // this.roomProvider.remove_user(this.room.id).subscribe();

      this.roomProvider.detail(this.room.id).subscribe((resp: any) => {
        this.room = resp.data;

        this.fight_rounds = this.room.fight_rounds;
        if (this.room.game_config) {
          this.config = JSON.parse(this.room.game_config);
        }
        this.startRound();
      });

      return;
    }

    this.fight_rounds = [];
    for (let i = 0; i < this.config.number_of_questions; i++) {
      this.fight_rounds.push(this.generateNumbers(true));
    }

    this.room.fight_rounds = this.fight_rounds;
    this.room.status = "playing";
    this.room.game_config = JSON.stringify(this.config);

    this.roomProvider
      .save(this.room)
      .subscribe((resp) => setTimeout(() => this.startRound(), 800));
  }

  startRound() {
    this.current_second = 0;
    this.isShowResultSignForText = false;
    this.isEnableEnterAnswered = false;

    // parse data
    this.config.timers = parseFloat(this.config.timers);
    this.config.answer_timers = parseFloat(this.config.answer_timers);
    this.config.current_questions = parseInt(this.config.current_questions);
    this.config.number_of_questions = parseInt(this.config.number_of_questions);
    this.config.number_of_rows = parseInt(this.config.number_of_rows);

    this.numbers = this.generateNumbers();
    let intervalSeconds =
      this.config.timers * this.config.number_of_rows * 1000;
    let intervalSecondsForAnswer =
      this.config.timers * (this.config.number_of_rows - 1) * 1000;

    const callbackInterval = (
      custom_intervalSeconds,
      custom_intervalSecondsForAnswer
    ) => {
      this.timeoutShowResultSignForText = setTimeout(() => {
        this.isShowResultSignForText = true;
        this.isEnableEnterAnswered = true;
        this.current_second++;
        this.playSound("bang.mp3");

        setTimeout(() => {
          const ele_math_container_main_controls_left_answer =
            document.getElementById("math_container_main_controls_left_answer");
          if (!ele_math_container_main_controls_left_answer) {
            return;
          }
          ele_math_container_main_controls_left_answer.focus();
          $(".scroll-content").addClass("flowhidden");
          $(".app-root").addClass("flowhidden");
        }, 400);

        this.timeoutAnswer = setTimeout(
          () => this.submit(),
          this.config.answer_timers * 1000
        );
      }, custom_intervalSeconds || intervalSeconds);

      this.timeoutEnableEnterAnswered = setTimeout(() => {
        if (this.room) {
          return;
        }

        this.isEnableEnterAnswered = true;

        setTimeout(() => {
          const ele_math_container_main_controls_left_answer =
            document.getElementById("math_container_main_controls_left_answer");
          if (!ele_math_container_main_controls_left_answer) {
            return;
          }
          ele_math_container_main_controls_left_answer.focus();
          $(".scroll-content").addClass("flowhidden");
          $(".app-root").addClass("flowhidden");
        }, 400);
      }, custom_intervalSecondsForAnswer || intervalSecondsForAnswer);
    };

    if (!this.numbers) {
      return;
    }

    if (this.isFlashCard) {
      this.currentAnswer = this.numbers;
      this.currentNumber = this.numbers;

      this.playSound(this.currentNumber, true);
      intervalSeconds = this.config.timers * 1000;
      intervalSecondsForAnswer = (this.config.timers - 1) * 1000;

      callbackInterval(null, null);
    } else {
      this.currentAnswer = this.calculateNumbers(this.numbers);

      this.currentNumberIndex = 0;
      this.currentNumber = this.numbers[this.currentNumberIndex];

      // this.playSound(this.currentNumber, true);

      this.callAISounds(
        this.generateNumbersString(this.numbers),
        () => callbackInterval(100, (this.config.timers - 1) * 1000),
        () => {
          this.intervalCountNumbers = setInterval(() => {
            this.currentNumberIndex = this.currentNumberIndex + 2;

            if (!this.numbers || !this.numbers[this.currentNumberIndex]) {
              clearInterval(this.intervalCountNumbers);
              return;
            }

            this.currentNumber = this.numbers[this.currentNumberIndex];
            if (this.numbers[this.currentNumberIndex - 1]) {
              this.playSound(this.numbers[this.currentNumberIndex - 1], false);

              this.currentNumber =
                this.numbers[this.currentNumberIndex - 1] +
                " " +
                this.currentNumber;
              this.playSound(this.currentNumber, true);
            }
          }, this.config.timers * 1000);

          callbackInterval(null, null);
        }
      );
    }
  }

  submit() {
    $(".scroll-content").removeClass("flowhidden");
    $(".app-root").removeClass("flowhidden");

    if (this.isTry) {
      this.submitTry();
      return;
    }
    if (this.timeoutShowResultSignForText) {
      clearTimeout(this.timeoutShowResultSignForText);
    }
    if (this.timeoutEnableEnterAnswered) {
      clearTimeout(this.timeoutEnableEnterAnswered);
    }

    if (this.intervalCountNumbers) {
      clearInterval(this.intervalCountNumbers);
    }

    if (this.timeoutAnswer) {
      clearTimeout(this.timeoutAnswer);
    }

    this.isShowResultSignForText = false;
    this.isEnableEnterAnswered = false;
    // this.myAnswer = (this.myAnswer);
    // this.currentAnswer = (this.currentAnswer);

    // log data
    this.logPost();

    if (`${this.myAnswer}` === `${this.currentAnswer}`) {
      this.success();
      this.count_correct_numbers++;
    } else {
      this.failed();
    }

    if (this.config.current_questions < this.config.number_of_questions) {
      this.resetNumbers();

      this.config.current_questions++;
      setTimeout(() => {
        this.startRound();
      }, 2000);
    } else {
      this.bravo();

      this.resetNumbers();

      this.isGaming = false;
      this.isTry = false;

      if (this.room) {
        this.room.fight_rounds = [];
        this.room.status = "new";
        this.roomProvider.save(this.room).subscribe();
      }
    }
  }

  logPost() {
    this.fisoMathProvider
      .log({
        log_group: this.log_group,
        user_id: window.localStorage.getItem("USER_ID"),
        level: this.level,
        sub_level: this.sub_level,
        board_name: this.board_name,
        questions: this.isFlashCard ? this.numbers : this.numbers.join(" "),
        answer: this.currentAnswer,
        user_answer: this.myAnswer,
        is_correct: `${this.myAnswer}` === `${this.currentAnswer}` ? 1 : 0,
        game_config: JSON.stringify(this.config),
        number_of_questions: this.config.number_of_questions,
        current_questions: this.config.current_questions,
        current_second: JSON.parse(JSON.stringify(this.current_second)),
        author_id: 0,
        room_id: this.room ? this.room.id : 0,
      })
      .subscribe((resp) => {
        // console.log(resp);
      });
  }

  submitTry() {
    $(".scroll-content").removeClass("flowhidden");
    $(".app-root").removeClass("flowhidden");

    $(".nav-bar").removeClass("disabled");
    this.isGaming = false;
    this.isTry = false;
    this.isShowResultSignForText = false;
    this.isEnableEnterAnswered = false;

    if (this.timeoutShowResultSignForText) {
      clearTimeout(this.timeoutShowResultSignForText);
    }

    if (this.timeoutEnableEnterAnswered) {
      clearTimeout(this.timeoutEnableEnterAnswered);
    }

    if (this.timeoutAnswer) {
      clearTimeout(this.timeoutAnswer);
    }

    // this.myAnswer = parseInt(this.myAnswer);
    // this.currentAnswer = parseInt(this.currentAnswer);

    if (`${this.myAnswer}` === `${this.currentAnswer}`) {
      this.success();
    } else {
      this.failed();
    }

    this.resetNumbers();
  }

  resetNumbers() {
    this.currentAnswer = "";
    this.currentNumber = "";
    this.myAnswer = "";
    this.numbers = [];
  }

  generateNumbers(fight_rounds = false) {
    if (!this.isFlashCard) {
      return this.generateSorobanNumbers(fight_rounds);
    }

    return this.generateFlashNumbers(fight_rounds);
  }

  generateSorobanNumbers(fight_rounds = false) {
    if (this.room && !fight_rounds) {
      return this.generateRoomStackQuestions();
    }

    if (this.examMode && parseInt(this.config.number_of_numbers) === 1) {
      this.algorithm = "algorithm_level2";
    }

    let numbers = [];
    switch (this.algorithm) {
      case "algorithm_level1":
        numbers = this.fisoMathProvider.algorithm_level1(
          this.type,
          this.config.number_of_numbers,
          this.config.number_of_rows
        );
        break;
      case "algorithm_level1_mix":
        this.type = this.fisoMathProvider.getRandomInt(1, 2);
        numbers = this.fisoMathProvider.algorithm_level1(
          this.type,
          this.config.number_of_numbers,
          this.config.number_of_rows
        );
        break;
      case "algorithm_level1_mix_big":
        this.type = this.fisoMathProvider.getRandomInt(3, 4);
        numbers = this.fisoMathProvider.algorithm_level1(
          this.type,
          this.config.number_of_numbers,
          this.config.number_of_rows
        );
        break;
      case "algorithm_level2":
        numbers = this.fisoMathProvider.algorithm_level2(
          this.config.number_of_numbers,
          this.config.number_of_rows
        );
        break;
      case "algorithm_level3":
        numbers = this.fisoMathProvider.algorithm_level3(
          this.config.number_of_numbers,
          this.config.number_of_rows
        );
        break;
      case "algorithm_level3_so_am":
        numbers = this.fisoMathProvider.algorithm_level3_so_am(
          this.config.number_of_numbers,
          this.config.number_of_rows
        );
        break;
      case "algorithm_level3_thap_phan":
        numbers = this.fisoMathProvider.algorithm_level3_thap_phan(
          this.config.number_of_numbers,
          this.config.number_of_rows,
          2
        );
        break;
      case "algorithm_level4_one":
        numbers = this.fisoMathProvider.algorithm_level4(
          this.config.number_of_numbers,
          1
        );
        break;
      case "algorithm_level4_two":
        numbers = this.fisoMathProvider.algorithm_level4(
          this.config.number_of_numbers,
          2
        );
        break;
      case "algorithm_level4_three":
        numbers = this.fisoMathProvider.algorithm_level4(
          this.config.number_of_numbers,
          3
        );
        break;
      case "algorithm_level4_four":
        numbers = this.fisoMathProvider.algorithm_level4(
          this.config.number_of_numbers,
          4
        );
        break;
      case "algorithm_level4_five":
        numbers = this.fisoMathProvider.algorithm_level4(
          this.config.number_of_numbers,
          5
        );
        break;
      case "algorithm_level4_six":
        numbers = this.fisoMathProvider.algorithm_level4(
          this.config.number_of_numbers,
          6
        );
        break;
      case "algorithm_level4_division_one":
        numbers = this.fisoMathProvider.algorithm_level4_division(
          this.config.number_of_numbers,
          1
        );
        break;
      case "algorithm_level4_division_two":
        numbers = this.fisoMathProvider.algorithm_level4_division(
          this.config.number_of_numbers,
          2
        );
        break;
      case "algorithm_level4_division_three":
        numbers = this.fisoMathProvider.algorithm_level4_division(
          this.config.number_of_numbers,
          3
        );
        break;
      case "training":
        const getRandomInt = (min, max) => {
          min = Math.ceil(min);
          max = Math.floor(max);
          return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
        };

        this.trainingQuestions = this.trainingQuestions || [];
        const questionIndex = getRandomInt(0, this.trainingQuestions.length);

        if (!this.trainingQuestions[questionIndex]) {
          numbers = [];
          break;
        }

        numbers = this.trainingQuestions[questionIndex].title.split(" ");
        this.config.number_of_rows = Math.ceil(numbers.length / 2);
        console.log(this.config.number_of_rows);
        break;
    }

    this.currentAnswer = this.calculateNumbers(this.numbers);
    return numbers;
  }

  generateFlashNumbers(fight_rounds) {
    if (this.room && !fight_rounds) {
      return this.generateRoomStackQuestions();
    }

    let min = 1;
    let max = 99;

    switch (this.type) {
      case FLASH_CARD_TYPE.FINGER:
        min = 1;
        max = parseInt(this.config.number_of_numbers) === 1 ? 9 : 99;
        break;
      case FLASH_CARD_TYPE.SOROBAN:
        min = 1;
        max = 9;
        for (let i = 0; i < this.config.number_of_numbers - 1; i++) {
          min = min * 10;
          max = max * 10 + 9;
        }
        break;
    }

    min = Math.ceil(min);
    max = Math.floor(max);

    const number = Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive

    this.currentAnswer = number;
    return number;
  }

  generateRoomStackQuestions() {
    if (!this.room && this.fight_rounds[this.config.current_questions - 1]) {
      return null;
    }

    console.log(this.fight_rounds[this.config.current_questions - 1]);
    return this.fight_rounds[this.config.current_questions - 1];
  }

  generateCurrentImage() {
    if (this.isFlashCard) {
      return this.generateFlashCurrentImage();
    }

    if (this.isFullAnswer) {
      return this.numbers.join(" ");
    }

    if (!this.numbers || !this.numbers.length) {
      return null;
    }

    let html = ``;
    _.forEach(this.numbers, (o, k) => {
      if (k > this.currentNumberIndex) {
        return;
      }

      // if (k === (this.numbers.length - 1)) {
      //     return;
      // }

      if (k % 2 === 0 && this.numbers[k - 1]) {
        html += ` ${this.numbers[k - 1]} `;
      }

      if (k % 2 === 0) {
        // html += Math.abs(o);
        html += o;
      }
    });

    return html;
  }

  generateFlashCurrentImage() {
    // check empty
    if (!this.numbers || this.numbers === ``) {
      return ``;
    }

    // check empty array
    if (Array.isArray(this.numbers) && !this.numbers.length) {
      return ``;
    }

    let html = ``;
    switch (this.type) {
      case FLASH_CARD_TYPE.FINGER:
        html = `<img class="is-finger"
                        src="assets/imgs/fingers/${this.numbers}.jpg" />`;
        break;
      case FLASH_CARD_TYPE.SOROBAN:
        const sorobans = (this.numbers + "").split("");
        _.forEach(sorobans, (o, k) => {
          html += `<img class="is-soroban"
                        src="assets/imgs/soroban/${o}${
            k === sorobans.length - 1 ? "_end" : ""
          }.jpg" />`;
        });
        break;
    }

    return html;
  }

  calculateNumbers(raw_numbers) {
    if (this.isFlashCard) {
      return raw_numbers;
    }

    let sum: any = 0;

    let prevSign = "+";

    _.forEach(raw_numbers, (o, k) => {
      if (k === 0) {
        o = parseFloat(o);
        sum = o;
        return;
      }

      if (k % 2 === 1) {
        prevSign = o;
        return;
      }

      o = parseFloat(o);
      switch (prevSign) {
        case "+":
          sum = sum + o;
          break;
        case "-":
          sum = sum - o;
          break;
        case "x":
          sum = sum * o;
          break;
        case "÷":
          sum = sum / o;
          break;
      }
    });

    if (this.algorithm === "algorithm_level3_thap_phan") {
      sum = parseFloat(sum);
      sum = sum.toFixed(2);
    } else {
      sum = parseInt(sum);
    }

    return sum;
  }

  success() {
    const audio = new Audio(
      APP_CONFIG.appURL + "/" + "assets/sounds/success.mp3"
    );
    audio.play();

    this.isSuccess = true;
    setTimeout(() => {
      this.isSuccess = false;
    }, 2000);
  }

  failed() {
    const audio = new Audio(APP_CONFIG.appURL + "/" + "assets/sounds/fail.mp3");
    audio.play();

    this.isFail = true;
    setTimeout(() => {
      this.isFail = false;
    }, 2000);
  }

  bravo() {
    $(".nav-bar").removeClass("disabled");

    const total_numbers = JSON.parse(
      JSON.stringify(this.config.number_of_questions)
    );
    const percent_correct =
      (parseInt(this.count_correct_numbers) / parseInt(total_numbers)) * 100;

    if (percent_correct >= 100) {
      this.bravoText = "EXCELLENT";
    } else if (percent_correct >= 80 && percent_correct <= 99) {
      this.bravoText = "VERY GOOD";
    } else {
      this.bravoText = "GOOD";
    }

    const audio = new Audio(
      APP_CONFIG.appURL + "/" + "assets/sounds/bravo.mp3"
    );
    audio.play();

    this.isBravo = true;
    this.isReStart = true;
    this.count_correct_numbers = 0;

    setTimeout(() => {
      this.isBravo = false;
    }, 4000);
  }

  playSound(fileName, isDigits = false) {
    if (this.config.game_type !== "listen") {
      return;
    }

    if (!isDigits) {
      switch (fileName) {
        case "+":
          fileName = "cong.mp3";
          break;
        case "-":
          fileName = "tru.mp3";
          break;
        case "x":
          fileName = "nhan.mp3";
          break;
        case ":":
          fileName = "chia.mp3";
          break;
        case ".":
          fileName = "cham.mp3";
          break;
      }

      const audio = new Audio(
        APP_CONFIG.appURL +
          "/" +
          `assets/sounds/${window.localStorage.getItem("LANG")}/${fileName}`
      );
      audio.play();
      return;
    }

    const digits = `${fileName}`.split("");
    digits.forEach((digit, digitKey) => {
      fileName = null;

      switch (digit) {
        case "0":
          fileName = "0.mp3";
          break;
        case "1":
          fileName = "1.mp3";
          break;
        case "2":
          fileName = "2.mp3";
          break;
        case "3":
          fileName = "3.mp3";
          break;
        case "4":
          fileName = "4.mp3";
          break;
        case "5":
          fileName = "5.mp3";
          break;
        case "6":
          fileName = "6.mp3";
          break;
        case "7":
          fileName = "7.mp3";
          break;
        case "8":
          fileName = "8.mp3";
          break;
        case "9":
          fileName = "9.mp3";
          break;
        case "+":
          fileName = "cong.mp3";
          break;
        case "-":
          fileName = "tru.mp3";
          break;
        case "x":
          fileName = "nhan.mp3";
          break;
        case ":":
          fileName = "chia.mp3";
          break;
        case ".":
          fileName = "cham.mp3";
          break;
      }

      if (!fileName) {
        return;
      }

      const soundFileName = JSON.parse(JSON.stringify(fileName));
      setTimeout(() => {
        const audio = new Audio(
          APP_CONFIG.appURL +
            "/" +
            `assets/sounds/${window.localStorage.getItem(
              "LANG"
            )}/${soundFileName}`
        );
        audio.play();
      }, digitKey * 800);
    });
  }

  onChangeMode() {
    if (this.config.game_type === "listen") {
      this.config.timers = "5";

      this.config.number_of_question_items = ["5"];
      this.config.number_of_questions = "5";
      this.config.row_items = [3, 5, 7];
      this.config.number_of_rows = 5;
    } else {
      this.config.number_of_question_items = ["10", "20", "30"];
      this.config.row_items = [
        2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      ];
    }
  }

  compareNumberDanger() {
    if (!(this.numbers && this.numbers.length)) {
      return false;
    }

    return (
      `${this.numbers[this.currentNumberIndex - 3]}${
        this.numbers[this.currentNumberIndex - 2]
      }` ===
      `${this.numbers[this.currentNumberIndex - 1]}${
        this.numbers[this.currentNumberIndex]
      }`
    );
  }

  changeExamLevel() {
    const levelConfig = { ...this.examlevels[this.examLevelIndex] };
    if (!levelConfig) {
      return;
    }

    levelConfig["timers"] =
      parseFloat(levelConfig["timers"]) /
      parseFloat(levelConfig["number_of_rows"]);
    // levelConfig['timers'] = Math.ceil(levelConfig['timers']);
    levelConfig["timers"] = `${levelConfig["timers"]}`;

    // levelConfig['answer_timers'] = parseFloat(levelConfig['answer_timers']) / parseFloat(levelConfig['number_of_rows']);
    // levelConfig['answer_timers'] = Math.ceil(levelConfig['answer_timers']);
    // levelConfig['answer_timers'] = `${levelConfig['answer_timers']}`;

    Object.assign(this.config, levelConfig);
  }

  ngOnDestroy() {
    $(".nav-bar").removeClass("disabled");

    if (this.timeoutShowResultSignForText) {
      clearTimeout(this.timeoutShowResultSignForText);
    }

    if (this.timeoutEnableEnterAnswered) {
      clearTimeout(this.timeoutEnableEnterAnswered);
    }

    if (this.timeoutAnswer) {
      clearTimeout(this.timeoutAnswer);
    }

    if (this.intervalCountNumbers) {
      clearInterval(this.intervalCountNumbers);
    }
  }

  forgotTimerText(number) {
    return parseFloat(number).toFixed(2);
  }

  formatNumberWithUI(currentNumber) {
    if (!currentNumber) {
      return currentNumber;
    }

    let clonedNumber = JSON.parse(JSON.stringify(currentNumber)) + "";

    clonedNumber = clonedNumber.replace(" ", "");
    clonedNumber = clonedNumber.replace("+-", "-");

    return clonedNumber;
  }
}



// WEBPACK FOOTER //
// ./src/components/soroban-math-container/soroban-math-container.ts